<template>
    <div class="sty-section" :class="bemFacets">
        <div class="grid--container">
            <sty-header :facets="['section-title']">
                <h2 class="u-reset u-reset__sty" :id="anchor" v-text="sectionTitle"/>
            </sty-header>
        </div>

        <div class="grid--container">
            <div class="grid--row sty-section--articles">
                <div class="grid--col sty-section--article">
                    <div class="grid--row sty-section--articles">
                        <div class="grid--col sty-section--article">
                            <sty-header>
                                <h3 class="u-reset u-reset__sty-h4">
                                    Facets
                                </h3>
                            </sty-header>

                            <div class="grid--row sty-section--facets" v-if="bridgeData">
                                <div class="grid--col sty-section--facet"
                                        v-for="facetName in bridgeData.facets"
                                        :key="facetName">
                                    <div class="grid--row sty-section--sizes">
                                        <div class="grid--col sty-section--size"
                                                v-for="sizeName in bridgeData.sizes"
                                                :key="sizeName">
                                            <simple-button :facets="[facetName, sizeName]">
                                                {{ getButtonDescription(facetName, sizeName) }}
                                            </simple-button>
                                        </div>
                                        <div class="grid--col sty-section--size"
                                                v-for="sizeName in bridgeData.sizes"
                                                :key="sizeName">
                                            <simple-button :facets="[facetName, sizeName]" disabled>
                                                {{ getButtonDescription(facetName, 'disabled') }}
                                            </simple-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StyHeader from 'framework/styleguide/header';
    import SimpleButton from 'framework/components/buttons/simple-btn/simple-btn.vue';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import getButtonDescription from './helpers';

    export default {
        components: {
            SimpleButton,
            StyHeader,
        },
        mixins: [
            bemMixin('sty-section'),
        ],
        props: {
            anchor: {
                type: String,
                required: true,
            },
            sectionTitle: {
                type: String,
                required: true,
            },
            bridgeData: {
                type: Object,
                required: true,
            },
        },
        methods: {
            getButtonDescription,
        },
    };
</script>
